import {
  CREATEREGISTRATIONPATIENT, GETREGISTRATIONPATIENT, GETREGISTRATIONPATIENTBYID, UPDATEREGISTRATIONPATIENT, DELETEREGISTRATIONPATIENT,
  CREATEALLREGISTRATIONPATIENT, UPDATEALLREGISTRATIONPATIENT,
  CREATEREGISTRATIONAPPOINTMENT, GETREGISTRATIONAPPOINTMENT, GETREGISTRATIONAPPOINTMENTBYID, UPDATEREGISTRATIONAPPOINTMENT, DELETEREGISTRATIONAPPOINTMENT,
  CREATEREGISTRATIONIPDVISIT, GETREGISTRATIONIPDVISIT, GETREGISTRATIONIPDVISITBYID, UPDATEREGISTRATIONIPDVISIT, DELETEREGISTRATIONIPDVISIT,
  CREATEREGISTRATIONOPDVISIT, GETREGISTRATIONOPDVISIT, GETREGISTRATIONOPDVISITBYID, UPDATEREGISTRATIONOPDVISIT, DELETEREGISTRATIONOPDVISIT,
  CREATEREGISTRATIONEMERGENCYVISIT, GETREGISTRATIONEMERGENCYVISIT, GETREGISTRATIONEMERGENCYVISITBYID, UPDATEREGISTRATIONEMERGENCYVISIT, DELETEREGISTRATIONEMERGENCYVISIT,
  CREATEPATIENTFAMILY, GETPATIENTFAMILY, GETPATIENTFAMILYBYID, UPDATEPATIENTFAMILY, DELETEPATIENTFAMILY,
  CREATEPATIENTCORPORATERECORD, GETPATIENTCORPORATERECORD, GETPATIENTCORPORATERECORDBYID, UPDATEPATIENTCORPORATERECORD, DELETEPATIENTCORPORATERECORD,
  CREATEPATIENTINSURANCERECORD, GETPATIENTINSURANCERECORD, GETPATIENTINSURANCERECORDBYID, UPDATEPATIENTINSURANCERECORD, DELETEPATIENTINSURANCERECORD,
  CREATEPATIENTCONSENTDECLARATION, GETPATIENTCONSENTDECLARATION, GETPATIENTCONSENTDECLARATIONBYID, UPDATEPATIENTCONSENTDECLARATION, DELETEPATIENTCONSENTDECLARATION,
  CREATEPATIENTINTERNATIONALRECORD, GETPATIENTINTERNATIONALRECORD, GETPATIENTINTERNATIONALRECORDBYID, UPDATEPATIENTINTERNATIONALRECORD, DELETEPATIENTINTERNATIONALRECORD,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    /* REGISTRATION - PATIENT */
    case CREATEREGISTRATIONPATIENT:
      return { ...state, registrationPatientSaveStatus: action.payload.success };
    case GETREGISTRATIONPATIENT:
      return { ...state, registrationPatientList: action.payload.data };
    case GETREGISTRATIONPATIENTBYID:
      return { ...state, registrationPatientDetail: action.payload.data };
    case UPDATEREGISTRATIONPATIENT:
      return { ...state, registrationPatientUpdateStatus: action.payload.success };
    case DELETEREGISTRATIONPATIENT:
      return { ...state, registrationPatientDeleteStatus: action.payload.success };
    case CREATEALLREGISTRATIONPATIENT:
      return { ...state, registrationPatientCreateAllStatus: action.payload.success };
    case UPDATEALLREGISTRATIONPATIENT:
      return { ...state, registrationPatientUpdateAllStatus: action.payload.success };

    /* REGISTRATION - APPOINTMENT */
    case CREATEREGISTRATIONAPPOINTMENT:
      return { ...state, registrationAppointmentSaveStatus: action.payload.success };
    case GETREGISTRATIONAPPOINTMENT:
      return { ...state, registrationAppointmentList: action.payload.data };
    case GETREGISTRATIONAPPOINTMENTBYID:
      return { ...state, registrationAppointmentDetail: action.payload.data };
    case UPDATEREGISTRATIONAPPOINTMENT:
      return { ...state, registrationAppointmentUpdateStatus: action.payload.success };
    case DELETEREGISTRATIONAPPOINTMENT:
      return { ...state, registrationAppointmentDeleteStatus: action.payload.success };

    /* REGISTRATION - IPD VISIT */
    case CREATEREGISTRATIONIPDVISIT:
      return { ...state, registrationIpdVisitSaveStatus: action.payload.success };
    case GETREGISTRATIONIPDVISIT:
      return { ...state, registrationIpdVisitList: action.payload.data };
    case GETREGISTRATIONIPDVISITBYID:
      return { ...state, registrationIpdVisitDetail: action.payload.data };
    case UPDATEREGISTRATIONIPDVISIT:
      return { ...state, registrationIpdVisitUpdateStatus: action.payload.success };
    case DELETEREGISTRATIONIPDVISIT:
      return { ...state, registrationIpdVisitDeleteStatus: action.payload.success };

    /* REGISTRATION - OPD VISIT */
    case CREATEREGISTRATIONOPDVISIT:
      return { ...state, registrationOpdVisitSaveStatus: action.payload.success };
    case GETREGISTRATIONOPDVISIT:
      return { ...state, registrationOpdVisitList: action.payload.data };
    case GETREGISTRATIONOPDVISITBYID:
      return { ...state, registrationOpdVisitDetail: action.payload.data };
    case UPDATEREGISTRATIONOPDVISIT:
      return { ...state, registrationOpdVisitUpdateStatus: action.payload.success };
    case DELETEREGISTRATIONOPDVISIT:
      return { ...state, registrationOpdVisitDeleteStatus: action.payload.success };

    /* REGISTRATION - EMERGENCY VISIT */
    case CREATEREGISTRATIONEMERGENCYVISIT:
      return { ...state, registrationEmergencyVisitSaveStatus: action.payload.success };
    case GETREGISTRATIONEMERGENCYVISIT:
      return { ...state, registrationEmergencyVisitList: action.payload.data };
    case GETREGISTRATIONEMERGENCYVISITBYID:
      return { ...state, registrationEmergencyVisitDetail: action.payload.data };
    case UPDATEREGISTRATIONEMERGENCYVISIT:
      return { ...state, registrationEmergencyVisitUpdateStatus: action.payload.success };
    case DELETEREGISTRATIONEMERGENCYVISIT:
      return { ...state, registrationEmergencyVisitDeleteStatus: action.payload.success };

    /* PATIENT FAMILIES */
    case CREATEPATIENTFAMILY:
      return { ...state, patientFamilySaveStatus: action.payload.success };
    case GETPATIENTFAMILY:
      return { ...state, patientFamilyList: action.payload.data };
    case GETPATIENTFAMILYBYID:
      return { ...state, patientFamilyDetail: action.payload.data };
    case UPDATEPATIENTFAMILY:
      return { ...state, patientFamilyUpdateStatus: action.payload.success };
    case DELETEPATIENTFAMILY:
      return { ...state, patientFamilyDeleteStatus: action.payload.success };

    /* PATIENT CORPORATE RECORDS */
    case CREATEPATIENTCORPORATERECORD:
      return { ...state, patientCorporateRecordSaveStatus: action.payload.success };
    case GETPATIENTCORPORATERECORD:
      return { ...state, patientCorporateRecordList: action.payload.data };
    case GETPATIENTCORPORATERECORDBYID:
      return { ...state, patientCorporateRecordDetail: action.payload.data };
    case UPDATEPATIENTCORPORATERECORD:
      return { ...state, patientCorporateRecordUpdateStatus: action.payload.success };
    case DELETEPATIENTCORPORATERECORD:
      return { ...state, patientCorporateRecordDeleteStatus: action.payload.success };

    /* PATIENT INSURANCE RECORDS */
    case CREATEPATIENTINSURANCERECORD:
      return { ...state, patientInsuranceRecordSaveStatus: action.payload.success };
    case GETPATIENTINSURANCERECORD:
      return { ...state, patientInsuranceRecordList: action.payload.data };
    case GETPATIENTINSURANCERECORDBYID:
      return { ...state, patientInsuranceRecordDetail: action.payload.data };
    case UPDATEPATIENTINSURANCERECORD:
      return { ...state, patientInsuranceRecordUpdateStatus: action.payload.success };
    case DELETEPATIENTINSURANCERECORD:
      return { ...state, patientInsuranceRecordDeleteStatus: action.payload.success };

    /* PATIENT CONSENT & DECLARATION */
    case CREATEPATIENTCONSENTDECLARATION:
      return { ...state, patientConsentDeclarationSaveStatus: action.payload.success };
    case GETPATIENTCONSENTDECLARATION:
      return { ...state, patientConsentDeclarationList: action.payload.data };
    case GETPATIENTCONSENTDECLARATIONBYID:
      return { ...state, patientConsentDeclarationDetail: action.payload.data };
    case UPDATEPATIENTCONSENTDECLARATION:
      return { ...state, patientConsentDeclarationUpdateStatus: action.payload.success };
    case DELETEPATIENTCONSENTDECLARATION:
      return { ...state, patientConsentDeclarationDeleteStatus: action.payload.success };
      
/* PATIENT INTERNATIONAL RECORDS */
    case CREATEPATIENTINTERNATIONALRECORD:
      return { ...state, patientInternationalRecordSaveStatus: action.payload.success };
    case GETPATIENTINTERNATIONALRECORD:
      return { ...state, patientInternationalRecordList: action.payload.data };
    case GETPATIENTINTERNATIONALRECORDBYID:
      return { ...state, patientInternationalRecordDetail: action.payload.data };
    case UPDATEPATIENTINTERNATIONALRECORD:
      return { ...state, patientInternationalRecordUpdateStatus: action.payload.success };
    case DELETEPATIENTINTERNATIONALRECORD:
      return { ...state, patientInternationalRecordDeleteStatus: action.payload.success };
    default:
      return state;
  }
}